const PAYMENT_PREFIXES = ["/checkout/", "/location/", "/session/", "/s/"]

/**
 * Whether a path belongs to the public payment pages, which load with the charging circle instead of the app wordmark.
 *
 * @param {string} pathname - current location pathname
 *
 * @returns {boolean} true for the checkout, location choice and session pages
 * */
export const isPublicPaymentPath = (pathname) =>
	PAYMENT_PREFIXES.some((prefix) => pathname.startsWith(prefix)) && !pathname.startsWith("/checkout/error")
